import { useCookie } from "@/features/shared/cookies/use-cookie.hook";
import { useGetCipUserQuery } from "@/services/cip.services";
import { QueryError, setCentralCipTokenHeader } from "@/services/config/api";
import { legacySessionToken } from "@/services/staff.services";
import { CipUser } from "@EspaceParkQC/sdk-services-legacy";
import { useEffect, useState } from "react";

interface UseGetCallParkingResult {
  data?: CipUser;
  loading: boolean;
  error: QueryError | null;
}

export default function useGetCipUser(): UseGetCallParkingResult {
  const [canFetch, setCanFetch] = useState(false);
  const { value: cookieValue } = useCookie<string>("cnp_cip_token");
  const cipToken = legacySessionToken(cookieValue);
  const getCipUser = useGetCipUserQuery({ queryOptions: { enabled: canFetch } });
  const data = getCipUser.data;
  const loading = getCipUser.isLoading;
  const error = getCipUser.error;

  useEffect(() => {
    if (cipToken) {
      setCentralCipTokenHeader(cipToken);
      setCanFetch(true);
    }
  }, [cipToken]);

  return {
    data,
    loading,
    error,
  };
}
